export const AUTH_REQUEST = 'AUTH_REQUEST'
export const AUTH_SUCCESS = 'AUTH_SUCCESS'
export const AUTH_ERROR = 'AUTH_ERROR'
export const AUTH_LOGOUT = 'AUTH_LOGOUT'

export const CONTACT_LISTS_REQUEST = 'CONTACT_LISTS_REQUEST'
export const CONTACT_LISTS_LOADING = 'CONTACT_LISTS_LOADING'
export const CONTACT_LISTS_SUCCESS = 'CONTACT_LISTS_SUCCESS'
export const CONTACT_LIST_SELECTED = 'CONTACT_LISTS_SELECT'
export const CONTACT_LIST_SELECT = 'CONTACT_LISTS_SELECTED'
export const CONTACT_LISTS_GET_BY_PARAMS = 'CONTACT_LISTS_GET_BY_PARAMS'

export const CONTACTS_LOADING = 'CONTACTS_LOADING'
export const CONTACTS_REQUEST = 'CONTACTS_REQUEST'
export const CONTACTS_SUCCESS = 'CONTACTS_SUCCESS'

export const USER_REQUEST = 'USER_REQUEST'
export const USER_SUCCESS = 'USER_SUCCESS'
export const USER_ERROR = 'USER_ERROR'
export const USER_UPDATE_PASSWORD = 'USER_UPDATE_PASSWORD'

export const PERSONS_FETCH = 'PERSONS_FETCH'
export const PERSONS_SET = 'PERSONS_SET'
export const PERSONS_SEARCH_UPDATE = 'PERSONS_SEARCH_UPDATE'
export const PERSONS_SEARCH_UPDATED = 'PERSONS_SEARCH_UPDATED'
export const PERSONS_COMPILE_STATS = 'PERSONS_COMPILE_STATS'
export const PERSONS_STATS_COMPILED = 'PERSONS_STATS_COMPILED'
export const PERSONS_LOADING = 'PERSONS_LOADING'
export const PERSONS_FETCH_PERSON = 'PERSONS_FETCH_PERSON'
export const PERSONS_UPDATE_PERSON = 'PERSONS_UPDATE_PERSON'
export const PERSONS_SET_PERSON = 'PERSONS_SET_PERSON'
export const PERSONS_DELETE = 'PERSONS_DELETE'
export const PERSONS_REMOVE = 'PERSONS_REMOVE'

export const SEARCH_SET_PARAMETERS = 'SEARCH_SET_PARAMETERS'
export const SEARCH_COMMIT_PARAMETERS = 'SEARCH_COMMIT_PARAMETERS'
export const SEARCH_TOGGLE_LIST = 'SEARCH_TOGGLE_LIST'
export const SEARCH_TOGGLE_LIST_COMMIT = 'SEARCH_TOGGLE_LIST_COMMIT'
export const SEARCH_CHECK_LISTS = 'SEARCH_CHECK_LISTS'
export const SEARCH_UNCHECK_ALL_LISTS = 'SEARCH_UNCHECK_ALL_LISTS'
export const SEARCH_COMMIT_CHECK_LISTS = 'SEARCH_COMMIT_CHECK_LISTS'
export const SEARCH_COMMIT_UNCHECK_ALL_LISTS = 'SEARCH_COMMIT_UNCHECK_ALL_LISTS'